// extracted by mini-css-extract-plugin
export default {"LangSwitcher":"MobileView_LangSwitcher__J6JBc"};